export var MODULE_BASE_PATH = "/brlegaldeposits";
export var USERS_MODULE_BASE_PATH = "/brusers";
export var ROUTE_PATHS = {
    TITLES_VERIFICATION: "".concat(MODULE_BASE_PATH, "/titles-verification"),
    PERIODICALS_VERIFICATION: "".concat(MODULE_BASE_PATH, "/periodicals-verification"),
    FREQUENCY_CONFLICTS: "".concat(MODULE_BASE_PATH, "/frequency-conflicts"),
    NEW_PERIODICALS: "".concat(MODULE_BASE_PATH, "/new-periodicals"),
    TITLES_WITH_ISBN: "".concat(MODULE_BASE_PATH, "/titles-with-isbn"),
    TITLES_WITHOUT_ISBN: "".concat(MODULE_BASE_PATH, "/titles-without-isbn"),
    REQUESTABLE_TITLES: "".concat(MODULE_BASE_PATH, "/requestable-titles"),
    PERIODICALS: "".concat(MODULE_BASE_PATH, "/periodicals"),
    PUBLISHERS: "".concat(MODULE_BASE_PATH, "/publishers"),
    LIBRARIES: "".concat(MODULE_BASE_PATH, "/libraries"),
    USERS: "".concat(MODULE_BASE_PATH, "/users"),
    PERIODICAL_CHECKS: "".concat(MODULE_BASE_PATH, "/periodical-checks"),
    OUTPUTS: "".concat(MODULE_BASE_PATH, "/outputs"),
    ADMIN: "".concat(MODULE_BASE_PATH, "/admin"),
};
export var usersEdit = function (id) { return "".concat(ROUTE_PATHS.USERS, "/").concat(id, "/edit"); };
export var libraryEdit = function (id) {
    return "".concat(ROUTE_PATHS.LIBRARIES, "/edit/").concat(id);
};
export var EXTERNAL_ROUTES = {
    USERS_MODULE: "".concat(USERS_MODULE_BASE_PATH, "/users"),
    USERS_MODULE_MY_PROFILE: "".concat(USERS_MODULE_BASE_PATH, "/my-profile"),
    USERS_MODULE_SELECT_ORG: "".concat(USERS_MODULE_BASE_PATH, "/my-profile/select-organization"),
};
